/**
 * Retorna a URL base da API
 * Em desenvolvimento, retorna string vazia para usar o proxy do React
 * Em produção, retorna a URL completa do backend
 */
export const getApiUrl = () => {
  // Se estiver em desenvolvimento (npm start), o proxy funciona
  // Se estiver em produção (build), precisa da URL completa
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  if (isDevelopment) {
    // Em desenvolvimento, usar proxy (requisições vão para /api)
    return '';
  } else {
    // Em produção, usar URL completa do backend
    return process.env.REACT_APP_API_URL || '';
  }
};

/**
 * Monta a URL completa para uma rota da API
 * @param {string} path - Caminho da rota (ex: '/api/produtos')
 * @returns {string} URL completa
 */
export const buildApiUrl = (path) => {
  const baseUrl = getApiUrl();
  // Remove barra inicial do path se houver, para evitar duplicação
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};
